<template>
  <div class="setting">
    <el-card>
      <div style="margin-bottom: 20px" class="setting-menu">
        <el-button
          type="primary"
          plain
          :class="activeType == 'CRS' ? 'active' : ''"
          @click="clickBtn('CRS')"
          >通用设置</el-button
        >
        <el-button
          type="primary"
          plain
          :class="activeType == 'PS' ? 'active' : ''"
          @click="clickBtn('PS')"
          >支付设置</el-button
        >
        <el-button
          type="primary"
          plain
          :class="activeType == 'CSS' ? 'active' : ''"
          @click="clickBtn('CSS')"
          >客服</el-button
        >
        <el-button
          type="primary"
          plain
          :class="activeType == 'AI' ? 'active' : ''"
          @click="clickBtn('AI')"
          >机构介绍</el-button
        >
        <el-button
          type="primary"
          plain
          :class="activeType == 'PA' ? 'active' : ''"
          @click="clickBtn('PA')"
          >隐私协议</el-button
        >
      </div>
      <CRS v-if="activeType == 'CRS'" v-auth="'setting_CRS'"></CRS>
      <PS v-if="activeType == 'PS'" v-auth="'setting_PS'"></PS>
      <CSS v-if="activeType == 'CSS'" v-auth="'setting_CSS'"></CSS>
      <AI v-if="activeType == 'AI'" v-auth="'setting_AI'"></AI>
      <PA v-if="activeType == 'PA'" v-auth="'setting_PA'"></PA>
    </el-card>
  </div>
</template>
<script>
import CRS from "./currencySetting.vue";
import PS from "./paySetting.vue";
import CSS from "./customerService.vue";
import AI from "./agentIntroduction.vue";
import PA from "./privacyAgreement.vue";
export default {
  components: { CRS, PS, CSS, AI, PA },
  data() {
    return {
      activeType: "CRS",
    };
  },
  methods: {
    clickBtn(activeType) {
      this.activeType = activeType;
    },
  },
  mounted() {
    let activeType = this.$route.query.activeType;
    if (activeType) {
      this.activeType = activeType;
    }
  },
};
</script>
<style scoped lang="less">
.setting-menu {
  .active {
    background-color: #409eff;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/setting/index.vue